module.exports = __webpack_public_path__ + "img/partner_5.4511a171.png";